import React from 'react'

import TicketsList from './ticketsList'

export default function IncidentsView() {
  return <TicketsList />
}
